import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PostHogAnalytics } from '@/components/analytics/PostHogAnalytics';
import { ScrollToTop } from '@/components/layout/ScrollToTop';
import { AppProviders } from '@/providers/AppProviders';
import App from './App';
import './fonts';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders>
      <BrowserRouter>
        <PostHogAnalytics>
          <ScrollToTop />
          <App />
        </PostHogAnalytics>
      </BrowserRouter>
    </AppProviders>
  </StrictMode>,
);
